import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, position } from 'styled-system';
import Text, { TextProps } from '../text/Text';

export type H5Props = Omit<TextProps, 'tag'> & { tag?: 'h5' };

const StyledH5: React.FC<H5Props> = ({ children, tag, ...otherProps }) => (
    <Text h5 tag="h5" {...otherProps}>
        {children}
    </Text>
);

const H5 = styled(StyledH5)`
    line-height: ${({ theme }) => theme.lineHeights.title};
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${position}
`;

H5.displayName = 'H5';
export default H5;
